<template>
  <div class="w-100">
    Appointment CREATION SMS for
    <appointment-object :appointment-number="appointmentNumber()" />

    sent to assistant
    <user-object
      :entity-id="appointmentAssistantId()"
      :name="appointmentAssistantName()"
      :open-new="true"
      :tooltip="appointmentAssistantProfile()"
    />

    <message-object :tooltip="messageContent()" />
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
